import { Home, Router, Radio, AlertTriangle, Map, Wifi, MessageSquare, Cpu } from 'lucide-react';

// Shared between the web sidebar (TechnicalLayout) and the app/mobile bottom-nav shell
// (TechnicalAppLayout) — same pattern as the admin side's navConfig.js, so both shells
// stay in sync with one edit.
export const navItems = [
  { id: 'dashboard',    to: '/technical/dashboard',    icon: Home,         label: 'Home' },
  { id: 'olt-status',   to: '/technical/olt-status',   icon: Router,       label: 'OLT Status' },
  { id: 'onus',         to: '/technical/onus',         icon: Radio,        label: 'ONU List' },
  { id: 'alarms',       to: '/technical/alarms',       icon: AlertTriangle, label: 'Alarms', badgeKey: 'alarms' },
  { id: 'network-map',  to: '/technical/network-map',  icon: Map,          label: 'Network Map' },
  { id: 'connections',  to: '/technical/connections',  icon: Wifi,         label: 'Active Connections' },
  { id: 'complaints',   to: '/technical/complaints',   icon: MessageSquare, label: 'My Complaints', badgeKey: 'complaints' },
  { id: 'acs',          to: '/technical/acs',          icon: Cpu,          label: 'ACS (TR-069)' },
];

// The bottom tab bar only has room for ~4-5 items before "More" — these are the ones a
// technician needs one tap away; everything else (including the desktop-dense admin pages)
// lives in the More sheet.
export const BOTTOM_TAB_IDS = ['dashboard', 'olt-status', 'onus', 'alarms'];
export const bottomTabs = BOTTOM_TAB_IDS.map(id => navItems.find(i => i.id === id));
export const moreItems = navItems.filter(i => !BOTTOM_TAB_IDS.includes(i.id));

export function getPageTitle(pathname) {
  return navItems.find(n => pathname.startsWith(n.to))?.label || 'Technical';
}
